export const POPOVER_FIELD_ERROR_MESSAGE_TOOLTIP_ID =
   'popover-field-error-message-tooltip'
export const POPOVER_DATA_FIELD_ERROR_ATTRIBUTE =
   'data-popover-field-error-message'

export const FIELD_ERROR_MESSAGE_TOOLTIP_ID = 'field-error-message-tooltip'

export const DATA_FIELD_ERROR_MESSAGE_ATTRIBUTE = 'data-field-error-message'

export const MAX_ENHANCERS_TO_SHOW_INLINE = 2
